import React from 'react';
import classnames from 'classnames';
import validate from 'validate.js';

import ExternalLink from 'ui/common/external-link';

export default function ethereumAddressLink({ ethereumAddress, className, ...otherProps }) {
  return (
    validate.isDefined(ethereumAddress) &&
    !validate.isEmpty(ethereumAddress) && (
      <ExternalLink
        className={classnames('text-truncate', className)}
        {...otherProps}
        href={`https://etherscan.io/address/${ethereumAddress}`}
      >
        {ethereumAddress}
      </ExternalLink>
    )
  );
}
